import { createContext, ReactNode, useContext, useState } from 'react';

interface BackofficeContextType {
  developerId: string | null;
  setDeveloperId: (id: string | null) => void;
  isBackofficeOn: boolean;
}

const BackofficeContext = createContext<BackofficeContextType | undefined>(undefined);

export const BackofficeProvider = ({ children }: { children: ReactNode }) => {
  const [developerId, setDeveloperId] = useState<string | null>(null);

  const value = {
    developerId,
    setDeveloperId,
    isBackofficeOn: process.env.REACT_APP_BACKOFFICE_MODE === 'internal_backoffice',
  };

  return <BackofficeContext.Provider value={value}>{children}</BackofficeContext.Provider>;
};

export const useBackoffice = () => {
  const context = useContext(BackofficeContext);
  if (context === undefined) {
    throw new Error('useBackoffice must be used within a BackofficeProvider');
  }
  return context;
};

export const ALL_DEVELOPERS = [
  {
    id: '95f15851-1d3e-423f-92ad-dea73e22d981',
    name: 'CopperX',
  },
  {
    id: 'ea235704-1d02-41a4-9415-5733d28d1d8a',
    name: 'Ambit Tech Pte. Ltd.',
  },
  {
    id: '446b7465-decc-4842-a37f-7f34447b4d8d',
    name: 'Inflow Pay',
  },
  {
    id: 'f8b9c086-87d4-410d-b9ca-c8273bf61332',
    name: 'Acctual',
  },
  {
    id: '0143026d-585f-4142-b9f0-00f48c10d8d9',
    name: 'Gloyo',
  },
  {
    id: '2a572ac1-a2b3-4d23-bbda-ac703e20e9d6',
    name: 'MON 3',
  },
  {
    id: '883c74eb-c408-45b6-83cb-489407bc9993',
    name: 'Andean Wide Capital SpA',
  },
  {
    id: 'f2db281a-44bb-4496-a1f3-1fab531c8b66',
    name: 'Fluida Inc.',
  },
  {
    id: '903145f6-a094-4c58-861a-87d532c68a06',
    name: 'Fractal 3 Ltd',
  },
  {
    id: '352cc573-e281-4c10-acea-36b70228e45a',
    name: 'SCB AG',
  },
  {
    id: '30eb4a8b-305b-471a-b8b8-eb484b7bf6dc',
    name: 'Crebit',
  },
  {
    id: '2e9d2b45-bf14-4a91-9666-22f84625983a',
    name: 'TokenPay',
  },
  {
    id: 'c22f62c5-8fa1-4ff2-b152-9ffe55fe1482',
    name: 'Genuine Technologies Ltd, Inc',
  },
  {
    id: '7b408912-f942-459e-bd0b-814c99eaf41e',
    name: 'Benjamin Shafii',
  },
  {
    id: '072bc489-8a8f-4891-afcf-8b817b7b3dbb',
    name: 'Daya',
  },
  {
    id: '1851cc3c-3119-4bd2-96d4-9a591ade50de',
    name: 'Tradevu',
  },
  {
    id: '9070f606-f306-4418-93e7-3d1230eee54f',
    name: 'ATIKH MOHAMED BANA',
  },
  {
    id: '04cd7c0e-e10e-44da-a837-b4f4f0da532f',
    name: 'Forestpay',
  },
  {
    id: 'fec7b79c-f8a8-4fca-895a-5af7f4c6be8b',
    name: 'Schnl (tolbel LLC)',
  },
  {
    id: '23813561-55df-4ed9-b4a5-47e6eb79d88c',
    name: 'Max Korolev',
  },
  {
    id: '4b2ba71d-7b79-49c3-824b-286a1376b7e8',
    name: 'Zaro',
  },
  {
    id: 'c9dea41d-867c-4c19-890d-41ff07d8c3f0',
    name: 'Yuro App',
  },
  {
    id: '313a6af5-47b2-482b-b536-7719bf86e19a',
    name: 'Defx',
  },
  {
    id: '3872bb3c-3eeb-488f-9117-4db7b4270890',
    name: 'Compose Finance',
  },
];
